﻿import $ from "jquery";

var partnerNameSelector = ".ccs-partner-name";

/* Enables "Partner Name" features.
----------------------------------------------------------*/
export default function enablePartnerName(partnerName) {
	$(partnerNameSelector).each(function () {
		const $partnerNameElement = $(this);
		$partnerNameElement.text(partnerName);
		$partnerNameElement.show();
	});
}
